import React, { useMemo, useState } from 'react';
import classNames from 'classnames';

import { Picker, Button, Icon } from '@tencent/spaui';

let ALL_SELECTED = false;

// 选项结构
const UserItemComponent = (props = {}) => {
  const { type = '', status = 'add', onClick, disabled, data = {} } = props;
  let disabledItem = false;
  if (typeof data.status === 'number' && data.status !== 0) {
    disabledItem = true;
  } else if (typeof data.leadsReceiveStatus === 'number' && data.leadsReceiveStatus === 0) {
    disabledItem = true;
  }

  const userName = useMemo(() => {
    let name = data.name || data.userGroupName;
    const invalidReasons = [];
    if (data.status !== 0 && !!data.name) {
      invalidReasons.push('登录状态关闭');
    }
    if (data.leadsReceiveStatus === 0) {
      invalidReasons.push('接收状态关闭');
    }
    if (invalidReasons.length > 0) {
      name = `${name}(${invalidReasons.join('、')})`;
    }
    return name;
  }, [
    data.name,
    data.userGroupName,
    data.status,
    data.leadsReceiveStatus,
  ]);

  if (type === 'user-list') {
    // 左侧的选择结构
    return (
      <li
        className={classNames('feed-item spaui-userpicker-feed-item', {
          checked: status === 'checked',
          disabled: disabledItem,
        })}
        onClick={disabledItem && status !== 'checked' ? () => {} : onClick}
      >
        <div className={classNames("feed-info spaui-userpicker-feed-info", { disabled: disabledItem })}>
          <span className={classNames("feed-title spaui-userpicker-feed-title", { disabled: disabledItem })}>
            { userName }
          </span>
          <p className="feed-desc spaui-userpicker-feed-desc">{data.describe}</p>
        </div>

        <span className="feed-action spaui-userpicker-feed-action">
          {status === 'checked' ? <i className="icon icon-checked"></i> : null}
        </span>
      </li>
    );
  }
  if (type === 'selection-list') {
    // 右侧的选中结构
    return (
      <li
        className={classNames('feed-item spaui-userpicker-feed-item', {
          'feed-item-delete spaui-userpicker-feed-item-delete': true,
        })}
      >
        <div className="feed-info spaui-userpicker-feed-info">
          <span className="feed-title spaui-userpicker-feed-title">
            { userName }
          </span>
        </div>
        <span className="feed-action spaui-userpicker-feed-action">
          <Button displayType="link" onClick={onClick}>
            删除
          </Button>
        </span>
      </li>
    );
  }
  return null;
};

// 自定义全选结构
const CheckAllComponent = (props = {}) => {
  const { disabled, checkAllLabel, checked = false, indeterminate = false, onChange } = props;
  return (
    <div className="feed-checkall">
      <Button onClick={onChange} disabled={disabled} displayType="link">
        {ALL_SELECTED ? '取消全选' : '全选'}
      </Button>
    </div>
  );
};

const SelectedTipComponent = (props = {}) => {
  const { selectionTitle = '', data = [] } = props;

  return data.length != 0 ? (
    <h3 className="title">已选择 {data.length} 个{props.targetName}</h3>
  ) : (
    <h3 className="title">已选择 0 个{props.targetName}</h3>
  );
};

const SearchInputLeftComponent = (props = {}) => <Icon type="viewer" />;

const CustomUserPicker = (props) => {
  const [allSelected, setAllSelected] = useState(false);

  const handleSelectChange = (...args) => {
    props.onChange(...args);
    setAllSelected(false);
    ALL_SELECTED = false;
  };

  const handleSelectAll = () => {
    if (allSelected) {
      handleSelectChange({}, []);
      setAllSelected(false);
      ALL_SELECTED = false;
      return;
    }
    const arr = props.data.filter((item) => {
      if (typeof item.status === 'number' && item.status !== 0) {
        return false;
      } if (typeof item.leadsReceiveStatus === 'number' && item.leadsReceiveStatus === 0) {
        return false;
      }
      return true;
    });
    const newAllValue = arr.map((item) => item.userId);
    handleSelectChange({}, newAllValue);
    setAllSelected(true);
    ALL_SELECTED = true;
  };
  return (
    <Picker
      searchPlaceholder={props.searchPlaceholder}
      searchFields={props.searchFields}
      UserItemComponent={UserItemComponent}
      CheckAllComponent={CheckAllComponent}
      SelectedTipComponent={SelectedTipComponent}
      SearchInputLeftComponent={SearchInputLeftComponent}
      onCheckAllChange={handleSelectAll}
      data={props.data}
      className={'store-picker'}
      disabled={props.disabled}
      value={props.value}
      onChange={handleSelectChange}
      checkAll={true}
      valueKey={props.valueKey}
    />
  );
}

export default CustomUserPicker;
